import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

interface Metric {
  label: string;
  value: string;
  change?: string;
  since: string;
  isPositive: boolean;
  subValue?: string;
  icon?: React.ElementType;
}

interface Props {
  metrics: Metric[];
}

const KeyMetrics: React.FC<Props> = ({ metrics }) => {
  return (
    <div className="key-metrics-container">
      {/* <h2 className="key-metrics-heading">Key Metrics</h2> */}
      <div className="key-metrics-grid">
        {metrics.map((metric, index) => (
          <div key={index} className="card metric-card">
            <div className="metric-header">
              {/* {metric.icon && <metric.icon size={18} color="#3b82f6" />} */}
              <p className="label">{metric.label}</p>
            </div>

            <div className="top-row">
              <span className="main-value">{metric.value}</span>
            </div>

            <div className="bottom-row">
              {metric.change && (
                <span
                  className={`change ${metric.isPositive ? "" : "negative"}`}
                >
                  {metric.isPositive ? (
                    <TrendingUp size={14} />
                  ) : (
                    <TrendingDown size={14} />
                  )}
                  {metric.change}
                </span>
              )}
              <span>{metric.since}</span>
            </div>

            {metric.subValue && (
              <small
                className="sub-value"
                style={{ color: "#999", fontSize: "11px" }}
              >
                {metric.subValue}
              </small>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyMetrics;
